const fastmatter = require('fastmatter');

module.exports = function fm(input) {
  let result = {
    attributes: {},
    body: input,
  };

  try {
    result = Object.assign({}, result, fastmatter(input.trim()));
  } catch (e) {
    // do nothing
  }

  return result;
};
